import { AdminDetailModel, AdminLoginRequestModel } from 'types/admin'
import axiosInstance from './axios'
import { ApiResponseModel } from 'types/common'

const adminApis = {
  login: (payload: AdminLoginRequestModel) =>
    axiosInstance.post<any, ApiResponseModel<AdminDetailModel | undefined>>(
      '/AdminLogon',
      payload
    ),
  logout: (userName: string) =>
    axiosInstance.post<any, ApiResponseModel<any>>('/logout', { userName }),
}

export default adminApis
